<rt-admins-select-dialog-form
  [heading]="heading"
  [subheading]="subheading"
  [assignments]="assignments"
  [lockedAssignments]="lockedAssignments"
  [lockedAssignmentsTooltip]="lockedAssignmentsTooltip"
  [preventAdminRemove]="preventAdminRemove"
  [admins]="allowedAdmins"
  [currentAdminId]="currentAdminId"
  [showCountBeforeSubheading]="showCountBeforeSubheading"
  [minSelectedAdmins]="minSelectedAdmins"
  [maxSelectedAdmins]="maxSelectedAdmins"
  (cancelClick)="cancel()"
  (submitClick)="submit($event)"
>
</rt-admins-select-dialog-form>
